
// export const myAction = ( state ) => {

// }

export const loginUser = ( state, { user, idToken } ) => {

    //console.log('Mutacion')
    //console.log(user)

    if ( idToken){
        localStorage.setItem('idToken', idToken)
        localStorage.setItem('idUser', user.id)
        localStorage.setItem('idPerfil', user.perfil)
        localStorage.setItem('name', user.name)
        state.idToken=idToken
        state.idPerfil=user.perfil
        state.name=user.name
    }

    state.id = user.id
    state.status = 'authenticated'

}


export const logout = (state) => {

    state.user = null
    state.idToken = null
    state.id = null
    state.idPerfil = null
    state.name = null
    state.status = 'not-authenticated'

    localStorage.removeItem('idToken')
    localStorage.removeItem('idUser')
    localStorage.removeItem('idPerfil')
    localStorage.removeItem('name')
}